import Navbar from "Components/Navbar/Navbar";
function PrivacyPolicy() {
  return <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1 py-16">
        <div className="container mx-auto px-4">
          <div className="mx-auto max-w-3xl prose prose-gray prose-invert">
            <h1 className="text-4xl font-bold tracking-tight mb-2">Privacy Policy</h1>
            <p className="text-muted-foreground text-sm mb-8">Last updated: February 1, 2026</p>

            <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">
              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">1. Information We Collect</h2>
                <p>We collect information you provide directly to us, including:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li><strong>Account Information:</strong> Name, email address, phone number, and password when you create an account</li>
                  <li><strong>Profile Data:</strong> Organization name, bio, address, and other application details</li>
                  <li><strong>Payment Information:</strong> Processed securely through Stripe — we do not store your full card details</li>
                  <li><strong>Usage Data:</strong> Information about how you interact with our Service, including events created, pages visited, and features used</li>
                  <li><strong>Communications:</strong> Messages you send to us or through the platform</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">2. How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>Provide, maintain, and improve the Service</li>
                  <li>Process your application and manage your account</li>
                  <li>Process transactions and send related information</li>
                  <li>Send you technical notices, updates, and administrative messages</li>
                  <li>Provide customer support</li>
                  <li>Monitor and analyze trends, usage, and activities</li>
                  <li>Detect and prevent fraudulent transactions and abuse</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">3. Information Sharing</h2>
                <p>
                  We do not sell your personal information. We may share information with:
                </p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li><strong>Service Providers:</strong> Third parties that help us operate (e.g., Stripe for payments, cloud hosting providers)</li>
                  <li><strong>Community Members:</strong> Limited profile information visible to members of your communities</li>
                  <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">4. Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal data. This includes encryption in transit (TLS/SSL), encryption at rest, regular security audits, and access controls. However, no method of transmission over the Internet is 100% secure.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">5. Data Retention</h2>
                <p>
                  We retain your personal data for as long as your account is active or as needed to provide services. You may request deletion of your account and associated data at any time through your account settings. Some data may be retained for legal or legitimate business purposes.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">6. Your Rights</h2>
                <p>Depending on your jurisdiction, you may have the right to:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>Access your personal data</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Request data portability</li>
                  <li>Withdraw consent at any time</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">7. Cookies and Tracking</h2>
                <p>
                  We use cookies and similar tracking technologies to enhance your experience. Essential cookies are required for the Service to function properly. You can manage cookie preferences through your browser settings.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">8. Children&apos;s Privacy</h2>
                <p>
                  Our Service is not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If we learn we have collected information from a child under 18, we will take steps to delete it.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">9. Changes to This Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the &quot;Last updated&quot; date. We encourage you to review this page periodically.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-foreground mb-3">10. Contact Us</h2>
                <p>
                  If you have questions about this Privacy Policy, please contact us at{" "}
                  <a href="mailto:privacy@shoup.co" className="text-primary hover:underline">
                    privacy@shoup.co
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      {/* <Footer /> */}
    </div>;
}
export {
  PrivacyPolicy as default
};
